import { IconButton } from "@funcional/react-ui";
import { Column, useTable } from "react-table";
import { IFormField } from "@pbm/registration-policies/contracts";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { useMemo } from "react";
import { IntlEnum } from "@funcional/react-intl-ui";
import { ReactTable } from "@funcional/react-table-ui";

interface FormFieldListProps {
  formFields: IFormField[];
  editFormField: Function;
  deleteFormField: Function;
}

export const FormFieldList = ({
  formFields,
  editFormField,
  deleteFormField,
}: FormFieldListProps) => {
  const columns: Column<IFormField>[] = useMemo(
    () =>
      [
        { Header: "Código", accessor: "code" },
        { Header: "Rótulo", accessor: "label" },
        {
          Header: "Tipo",
          accessor: "type",
          Cell: ({ value }) => <IntlEnum name="field_type" value={value} />,
        },
        {
          Header: "Preenchimento",
          accessor: "display",
          Cell: ({ value }) => <IntlEnum name="field_display" value={value} />,
        },
        { Header: "Descrição", accessor: "description" },
        { Header: "Valor Padrão", accessor: "defaultValue" },
        {
          Header: "Entidade",
          accessor: "entityField",
          Cell: ({ value }) => <IntlEnum name="entity_field" value={value} />,
        },
        {
          Header: "Opções",
          accessor: "options",
          Cell: ({ value }: { value: any[] }) => value?.length || 0,
        },
        { Header: "API Externa", accessor: "externalApiField" },
      ] as Column<IFormField>[],
    []
  );

  const tableInstance = useTable(
    {
      columns,
      data: formFields,
    },
    (hooks: any) => {
      hooks.visibleColumns.push((columns: any) => [
        ...columns,
        {
          id: "crud",
          Header: "",
          Cell: ({ row }: any) => (
            <div className="">
              <IconButton title="Editar" onClick={() => editFormField(row)}>
                <EditIcon />
              </IconButton>

              <IconButton title="Excluir" onClick={() => deleteFormField(row)}>
                <DeleteIcon />
              </IconButton>
            </div>
          ),
        },
      ]);
    }
  );

  return <ReactTable tableInstance={tableInstance} />;
};
